import React,{useState} from  'react'

interface AppTextSearchProps {
	value?: string
	onChange?: (value: string) => void
}

export const AppTextSearch = (props:AppTextSearchProps) =>{

    const[value ,setValue] = useState(props.value||'')
    const[active, setActive] = useState(false)

    const hanldBlur = () =>{
        let newValue = refInput.current.value;
        if(newValue !== value){
            props.onChange && props.onChange(newValue)
            setValue(newValue)
        }
        setActive(false)
    }

    const handleAllChecked = () =>{
        if(value === '') return;
        if(refInput && refInput.current) {
            refInput.current.value = '';
        }
        setValue('');
    }

    let allChecked = value==='';

    const refInput = React.createRef<HTMLInputElement>()
    return ( 
    <div className='app-search-item-container'>
        <div className='app-search-item-left'>
            <div className='app-search-all-content'>
                <span className='app-all-option' 
					data-checked={allChecked} 
					onClick={handleAllChecked}>全部
					<i className="qcciconfont-select app-all-option-checked-icon" 
					hidden={!allChecked} />
				</span>
            </div>
        </div>
        <div className='app-search-item-right'>
            <div className='app-search-text-container'>
                <input ref={refInput} 
                    className='app-input-search' 
                    defaultValue={props.value || ''}
                    data-active ={active}  
                    onFocus={e => setActive(true)}
                    onBlur={hanldBlur}
                    style ={{width:300}}
                />
            </div>
        </div>
    </div>)
}


// WEBPACK FOOTER //
// ./src/qcc/AppSearchItem/AppTextSearch.tsx